<script>

export let about = false;
</script>

<h2 class="UITitle" class:_about={about}>
	<slot />
</h2>

<style global>
	.UITitle {
		padding: 1em 0;
		max-width: 800px;
		margin: 0 auto;
		font-size: 2em;
		text-align: center;
		color:#fff;
		font-weight:bold;
		text-shadow: 0 0 16px rgb(0 0 0 / 50%);
		letter-spacing: 0.05em;
	}
	.UITitle._about {
		padding: 0.25em 0;
		font-size: 2.4em;
		line-height: 1.4em;
	}
	.pc .UITitle._about {
		padding: 0.25em 0;
		font-size: 3.125em;
	}
	.UITitle._about ruby rt {
		font-size: 0.4em;
		letter-spacing:0;
		text-align: center;
	}
	.pc .UITitle._about ruby rt {
		letter-spacing: -0.05em;
	}
	.UITitle._about span {
		font-size: 0.7em;
	}
	.UITitle div {
		font-size: 0.7em;
	}
</style>
